import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/site-data";

export default function FloatingWhatsapp() {
  const href = `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(
    "Hi DreamFly Travels, I'd like a quote."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 bg-[#2C7A7B] hover:bg-[#0F3D3E] text-white rounded-full px-5 py-3.5 text-sm font-medium shadow-[0_20px_50px_-15px_rgba(44,122,123,0.7)] transition-colors"
    >
      <MessageCircle size={18} />
      <span className="hidden sm:inline">WhatsApp us</span>
    </a>
  );
}
